export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/ApplePay.411f4bf6.svg","height":15,"width":36,"blurWidth":0,"blurHeight":0};